export default __webpack_public_path__ + "static/media/MP5_7.0449fd28.png";